// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sessions-container {
    max-height: 60%;
    width: 100%;
    background: #f0fdfb;
    overflow: hidden;
  }

  
  .sessions-header {
    width: 100%;
    padding: 10px;
    padding-left: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: transparent;
    border: none;
    cursor: pointer;
    font-size: 16px;
    color: #111827;
  }

  .header-content {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  

  .icon {
    font-size: 20px;
  }

  .title{
    font-size: 16px;
  }
  .unread-badge {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    background-color: #ef4444;
    color: white;
    border-radius: 9999px;
    font-size: 12px;
    font-weight: 500;
  }

  .chevron {
    width: 20px;
    height: 20px;
    transition: transform 0.2s ease;
  }
  
  .chevron.rotate {
    transform: rotate(180deg);
  }


  .all-sessions{
    height: 90%;
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .search-container {
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 8px;
    border-bottom: 1px solid #e5e7eb;
  }
   
  .search-wrapper {
    position: relative;
    width: 100%;
  }
   
  .search-icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #9ca3af;
    pointer-events: none;
  }
   
  .search-input {
    width: 100%;
    padding: 8px 12px 8px 36px;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    font-size: 14px;
    color: #111827;
    background-color: white;
    transition: all 0.2s ease;
  }
   
  .search-input:hover {
    border-color: #d1d5db;
  }
   
  .search-input:focus {
    outline: none;
    border-color: #0d9488;
    box-shadow: 0 0 0 2px rgba(13, 148, 136, 0.1);
  }
   
  .search-input::placeholder {
    color: #9ca3af;
  }


   
  .sessions-list {
    display: flex;
    flex-direction: column;
    max-height: 90%;
    overflow-y: scroll;
  }
  
  .session-item {
    padding: 12px;
    padding-left: 16px;
    border-bottom: 1px solid #e5e7eb;
    background: white;
    cursor: pointer;
    transition: background-color 0.2s ease;
  }

  .session-item-selected{
    padding: 12px;
    padding-left: 16px;
    border-bottom: 1px solid #e5e7eb;
    background: rgb(194, 193, 193);
    cursor: pointer;
    transition: background-color 0.2s ease;
  }
  
  .session-item:hover {
    background: #eef3f9;
  }

  .name-container{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .patient-name {
    margin: 0;
    font-size: 16px;
    font-weight: 500;
    color: #111827;
  }

  .circular-dot{
    height: 10px;
    width: 10px;
    border-radius: 50%;
  }
  
  .session-details {
    margin-top: 4px;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  
  .session-time {
    font-size: 14px;
    color: #6b7280;
  }
  

  
  @media (max-width: 600px) {
    .sessions-container {
      max-height: 66%;
      padding: 0px 10px;
    }
    .sessions-header {
      padding: 10px 4px;
      font-size: 15px;
    }
    
    .search-container {
      padding: 10px 0px;
    }
    .search-icon {
      left: 8px;
    }

    .search-input {
      padding: 8px 4px 8px 30px;
      font-size: 16px;

    }

    .session-item {
      padding: 8px;
    }
    .session-item-selected{
      padding: 8px;
    }

  }
  `, "",{"version":3,"sources":["webpack://./src/components/dashboardLeftSectionComponent/SessionList.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,gBAAgB;EAClB;;;EAGA;IACE,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;;EAGA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;IACrB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,+BAA+B;EACjC;;EAEA;IACE,yBAAyB;EAC3B;;;EAGA;IACE,WAAW;IACX,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,gCAAgC;EAClC;;EAEA;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,cAAc;IACd,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,0BAA0B;IAC1B,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,uBAAuB;IACvB,yBAAyB;EAC3B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,qBAAqB;IACrB,6CAA6C;EAC/C;;EAEA;IACE,cAAc;EAChB;;;;EAIA;IACE,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,gCAAgC;IAChC,iBAAiB;IACjB,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,gCAAgC;IAChC,8BAA8B;IAC9B,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;;;EAIA;IACE;MACE,eAAe;MACf,iBAAiB;IACnB;IACA;MACE,iBAAiB;MACjB,eAAe;IACjB;;IAEA;MACE,iBAAiB;IACnB;IACA;MACE,SAAS;IACX;;IAEA;MACE,yBAAyB;MACzB,eAAe;;IAEjB;;IAEA;MACE,YAAY;IACd;IACA;MACE,YAAY;IACd;;EAEF","sourcesContent":[".sessions-container {\n    max-height: 60%;\n    width: 100%;\n    background: #f0fdfb;\n    overflow: hidden;\n  }\n\n  \n  .sessions-header {\n    width: 100%;\n    padding: 10px;\n    padding-left: 16px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    font-size: 16px;\n    color: #111827;\n  }\n\n  .header-content {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n  }\n  \n\n  .icon {\n    font-size: 20px;\n  }\n\n  .title{\n    font-size: 16px;\n  }\n  .unread-badge {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 24px;\n    height: 24px;\n    background-color: #ef4444;\n    color: white;\n    border-radius: 9999px;\n    font-size: 12px;\n    font-weight: 500;\n  }\n\n  .chevron {\n    width: 20px;\n    height: 20px;\n    transition: transform 0.2s ease;\n  }\n  \n  .chevron.rotate {\n    transform: rotate(180deg);\n  }\n\n\n  .all-sessions{\n    height: 90%;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n  }\n\n  .search-container {\n    padding-left: 10px;\n    padding-right: 10px;\n    padding-bottom: 8px;\n    border-bottom: 1px solid #e5e7eb;\n  }\n   \n  .search-wrapper {\n    position: relative;\n    width: 100%;\n  }\n   \n  .search-icon {\n    position: absolute;\n    left: 12px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: #9ca3af;\n    pointer-events: none;\n  }\n   \n  .search-input {\n    width: 100%;\n    padding: 8px 12px 8px 36px;\n    border: 1px solid #e5e7eb;\n    border-radius: 6px;\n    font-size: 14px;\n    color: #111827;\n    background-color: white;\n    transition: all 0.2s ease;\n  }\n   \n  .search-input:hover {\n    border-color: #d1d5db;\n  }\n   \n  .search-input:focus {\n    outline: none;\n    border-color: #0d9488;\n    box-shadow: 0 0 0 2px rgba(13, 148, 136, 0.1);\n  }\n   \n  .search-input::placeholder {\n    color: #9ca3af;\n  }\n\n\n   \n  .sessions-list {\n    display: flex;\n    flex-direction: column;\n    max-height: 90%;\n    overflow-y: scroll;\n  }\n  \n  .session-item {\n    padding: 12px;\n    padding-left: 16px;\n    border-bottom: 1px solid #e5e7eb;\n    background: white;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n  }\n\n  .session-item-selected{\n    padding: 12px;\n    padding-left: 16px;\n    border-bottom: 1px solid #e5e7eb;\n    background: rgb(194, 193, 193);\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n  }\n  \n  .session-item:hover {\n    background: #eef3f9;\n  }\n\n  .name-container{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  \n  .patient-name {\n    margin: 0;\n    font-size: 16px;\n    font-weight: 500;\n    color: #111827;\n  }\n\n  .circular-dot{\n    height: 10px;\n    width: 10px;\n    border-radius: 50%;\n  }\n  \n  .session-details {\n    margin-top: 4px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n  \n  .session-time {\n    font-size: 14px;\n    color: #6b7280;\n  }\n  \n\n  \n  @media (max-width: 600px) {\n    .sessions-container {\n      max-height: 66%;\n      padding: 0px 10px;\n    }\n    .sessions-header {\n      padding: 10px 4px;\n      font-size: 15px;\n    }\n    \n    .search-container {\n      padding: 10px 0px;\n    }\n    .search-icon {\n      left: 8px;\n    }\n\n    .search-input {\n      padding: 8px 4px 8px 30px;\n      font-size: 16px;\n\n    }\n\n    .session-item {\n      padding: 8px;\n    }\n    .session-item-selected{\n      padding: 8px;\n    }\n\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
